export { Woman as default } from './Woman';
